jQuery(document).ready(function($){
	var mouseTarget;

	$('#shop_filters .price_slider').mousedown(function(){
		mouseTarget = 'price_slider';
	}).mouseup(function(){
		mouseTarget = '';
		$(this).next('.price_slider_amount').find('button').click();
	});

	$(document).on('mouseup', function(e) {
	    if(mouseTarget == 'price_slider'){ //if mousedown was triggered on the price slider and mouseup triggered not on the slider
	    	$('#shop_filters .price_slider').trigger('mouseup');
	      	mouseTarget = '';
	    }
	});
}); 